import "./categoryMovies.css";
import Movie from "./../Movie/Movie";
import { useProducts } from "./../../Context/products-context.js";
import { useVideos } from "./../../Context/videos-context";
import { useEffect } from "react";
import { useToken } from "../../Context/token-context";

const CategoryMovies = ({ category }) => {
  const { stateVideo, dispatchVideo } = useVideos();

  const { encodedToken } = useToken();

  useEffect(() => {
    fetch("/api/videos", {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        dispatchVideo({ type: "Setup", payload: data.videos });
      });
  }, [dispatchVideo]);

  const { state, dispatch } = useProducts();

  useEffect(() => {
    localStorage.setItem("LIKED_ARRAY", JSON.stringify(state.likedArray));
    localStorage.setItem(
      "WATCH_LATER_ARRAY",
      JSON.stringify(state.watchLaterArray)
    );
    localStorage.setItem("HISTORY_ARRAY", JSON.stringify(state.historyArray));
    localStorage.setItem("DISLIKED_ARRAY", JSON.stringify(state.dislikedArray));
  }, [
    state.likedArray,
    state.watchLaterArray,
    state.historyArray,
    state.dislikedArray,
  ]);

  return (
    <div className="CategoryMovies">
      <h1>{category}</h1>
      <div className="category-movies-section">
        {stateVideo.videosArray.map((movie) => {
          return (
            movie.category === category && (
              <Movie
                key={movie._id}
                _id={movie._id}
                source={movie.source}
                thumbnail={movie.thumbnail}
                title={movie.title}
                category={movie.category}
                addToLiked={() =>
                  dispatch({
                    type: "Add to Liked",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                removeFromLiked={() =>
                  dispatch({
                    type: "Remove from Liked",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                addToWatchLater={() =>
                  dispatch({
                    type: "Add to Watch Later",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                addToHistory={() =>
                  dispatch({
                    type: "Add to History",
                    payload: { video: movie, token: encodedToken },
                  })
                }
                likeButtonColor={
                  state.likedArray.find((element) => element.id === movie.id)
                    ? "var(--binge-red)"
                    : "whitesmoke"
                }
                dislikeButtonColor={
                  state.dislikedArray.find((element) => element.id === movie.id)
                    ? "var(--binge-red)"
                    : "whitesmoke"
                }
                watchLaterButtonColor={
                  state.watchLaterArray.find(
                    (element) => element.id === movie.id
                  )
                    ? "var(--binge-red)"
                    : "whitesmoke"
                }
              />
            )
          );
        })}
      </div>
    </div>
  );
};

export default CategoryMovies;
